export default __webpack_public_path__ + "static/media/android_step_2_Hk.03a00f42.jpg";